// extracted by mini-css-extract-plugin
module.exports = {"filtersopen__list":"FiltersOpen-module__filtersopen__list___2GvzP","filtersopen__item":"FiltersOpen-module__filtersopen__item___1xF37"};